const INITIAL_STATE = {
  programFilter: '',
  selectedProgram: 0
};

export const programsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'UPDATE_ADMIN_PROGRAMS_PAGE_FILTER_STRING':
      return {
        ...state,
        programFilter: action.payload
      };
    case 'UPDATE_ADMIN_PROGRAMS_PAGE_SELECTED_PROGRAM':
      return {
        ...state,
        selectedProgram: action.payload
      };
    default:
      return state;
  }
};
